import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Campaign } from '../../types';

interface CampaignsState {
  list: Campaign[];
  selected: Campaign | null;
  loading: boolean;
  error: string | null;
}

const initialState: CampaignsState = {
  list: [],
  selected: null,
  loading: false,
  error: null,
};

const campaignsSlice = createSlice({
  name: 'campaigns',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setCampaigns: (state, action: PayloadAction<Campaign[]>) => {
      state.list = action.payload;
      state.loading = false;
    },
    setSelectedCampaign: (state, action: PayloadAction<Campaign | null>) => {
      state.selected = action.payload;
    },
    addCampaign: (state, action: PayloadAction<Campaign>) => {
      state.list.unshift(action.payload);
    },
    updateCampaign: (state, action: PayloadAction<Campaign>) => {
      const index = state.list.findIndex(c => c.id === action.payload.id);
      if (index !== -1) {
        state.list[index] = action.payload;
      }
      if (state.selected?.id === action.payload.id) {
        state.selected = action.payload;
      }
    },
    deleteCampaign: (state, action: PayloadAction<string>) => {
      state.list = state.list.filter(c => c.id !== action.payload);
      if (state.selected?.id === action.payload) {
        state.selected = null;
      }
    },
    setError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.loading = false;
    },
  },
});

export const { 
  setLoading, 
  setCampaigns, 
  setSelectedCampaign, 
  addCampaign, 
  updateCampaign, 
  deleteCampaign, 
  setError 
} = campaignsSlice.actions;
export default campaignsSlice.reducer; 